import { TransactionSupportComingSoonPanel } from '@/components/common/transactionSupportComingSoonPanel'
import { cn } from '@/utils/cn'
import type { ComponentProps } from 'react'

export const FixedTermMarketSidePanel = ({ className, ...props }: ComponentProps<'aside'>) => (
  <aside className={cn('h-fit flex-col gap-4', className)} data-role="side-panel" data-location="side" {...props}>
    <TransactionSupportComingSoonPanel description="Fixed-term transactions are coming soon. Track rates and explore markets in read-only mode now." />
  </aside>
)
